import * as React from "react"
import Head from "next/head"
import { ReactQueryDevtools } from "react-query/devtools"
import { Box } from "@mui/material"
import { useRouter } from "next/router"
import Amplify from "aws-amplify"
import { ErrorBoundary } from "react-error-boundary"
import { LicenseInfo } from "@mui/x-data-grid-pro"

import { AuthProvider } from "context/auth.js"
import { SiteSettingsProvider } from "context/siteSettings.js"
import EmptyMessage from "components/EmptyMessage"
import ToastProvider from "context/ToastProvider"
import CommandBarProvider from "context/CommandBarProvider"
import { ThemeProvider } from "util/theme.js"
import { QueryClientProvider } from "context/api/QueryClientProvider"
import DashboardLayout from "layouts/DashboardLayout"
import DefaultLayout from "layouts/DefaultLayout"

import "util/amplify.css"

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: process.env.NEXT_PUBLIC_AWS_REGION,
    userPoolId: process.env.NEXT_PUBLIC_AWS_COGNITO_USER_POOL_ID,
    userPoolWebClientId:
      process.env.NEXT_PUBLIC_AWS_COGNITO_USER_POOL_CLIENT_ID,
  },
})

LicenseInfo.setLicenseKey(
  "7b50171a1cfb713ff3dbecd471a8cb9eT1JERVI6NDExNTksRVhQSVJZPTE2ODA3MzUyODQwMDAsS0VZVkVSU0lPTj0x"
)

function MyApp({ Component, pageProps }) {
  const router = useRouter()

  let LayoutComponent = DefaultLayout
  if (router.pathname.startsWith("/dashboard")) {
    LayoutComponent = DashboardLayout
  }

  return (
    <ErrorBoundary
      FallbackComponent={
        <Box
          sx={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "sans-serif",
          }}
        >
          <EmptyMessage
            type="error"
            message="Something went wrong with one of the services we rely on :("
          />
        </Box>
      }
    >
      <QueryClientProvider>
        <ReactQueryDevtools
          position="bottom-right"
          toggleButtonProps={{
            style: { right: 70, bottom: 10, zIndex: 3 },
          }}
          panelProps={{
            style: {
              backgroundColor: "rgba(0,0,0,0.75)",
            },
          }}
        />
        <ThemeProvider>
          <AuthProvider>
            <SiteSettingsProvider>
              <CommandBarProvider>
                <ToastProvider />
                <LayoutComponent>
                  <Head>
                    <title key="title">Luz</title>
                    <link
                      rel="shortcut icon"
                      href={
                        process.env.NODE_ENV === "development"
                          ? "/dev-favicon.ico"
                          : "/favicon.ico"
                      }
                    />
                  </Head>
                  <Component {...pageProps} />
                </LayoutComponent>
              </CommandBarProvider>
            </SiteSettingsProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default MyApp
